/* eslint-disable no-useless-escape */
import { Encoder } from "./encoder"

export const SYMBOLS_REGEX =
  /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|`|-|{|}|\||\\/g

export function regexIDCard() {
  const re =
    /^(0[0-9]{2}|1[0-8][0-9]|2[0-4][0-9]|25[0-6])([0-9])([0-9]{2})([0-9]{6})$/
  return re
}
export function regexCheckSpaceAndMaxLength() {
  const re = /^(?!\s*$).{1,500}$/u
  return re
}

export function regexCheckSpaceAndNoIconEmoji() {
  const re =
    /^(?!\s*$)(?!.*[\p{Emoji_Presentation}\p{Extended_Pictographic}]).+$/u
  return re
}

export function regexTimeLate() {
  const re = /^[0-9]\d*$/
  return re
}

export function generateRandomString() {
  return Math.random().toString(36).substr(7)
}
export const getRegexPassword = () => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
  return regex
}
export function getRegexUsername() {
  const re = /^[a-zA-Z0-9_]{6,16}$/
  return re
}
// regex số đơn
export function getRegexDeclareNumber(Prefix) {
  let startingNumber
  let regex

  switch (true) {
    case Prefix.startsWith("SĐ"):
    case Prefix.startsWith("CĐ"):
      startingNumber = Prefix.substr(Prefix.length - 1)
      regex = new RegExp(`^(${startingNumber})-\\d{4}-\\d{5}$`)
      return regex
    default:
      return {} // Trường hợp không phù hợp
  }
}
//regex số VBBH
export function getRegexVBBHNumber(Prefix) {
  let startingNumber
  let regex

  switch (true) {
    case Prefix.startsWith("GH"):
    case Prefix.startsWith("DT"):
    case Prefix.startsWith("SB"):
    case Prefix.startsWith("PB"):
    case Prefix.startsWith("RB"):
    case Prefix.startsWith("RBPB"):
    case Prefix.startsWith("ĐC"):
    case Prefix.startsWith("ĐN"):
    case Prefix.startsWith("CB"):
    case Prefix.startsWith("LX"):
      startingNumber = Prefix.substr(Prefix.length - 1)
      regex = new RegExp(`^(${startingNumber})-(\\d{5,7})-000$`)
      return regex
    default:
      return {} // Trường hợp không phù hợp
  }
}

export function generateCode(str, underscore = true) {
  if (!str) return ""
  str = str?.toLowerCase()
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i")
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
  str = str.replace(/đ/g, "d")
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " ",
  )
  str = str.replace(/ + /g, " ")
  str = str.trim()
  str = str.toUpperCase()
  const matches = str.match(/\b(\w)/g)
  if (!matches) return ""
  const acronym = matches.join("")
  if (underscore) return `${acronym}_`
  return acronym
}

export function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}
export function validatePhone(phone) {
  if (
    ((phone.startsWith("01") ||
      phone.startsWith("028") ||
      phone.startsWith("023") ||
      phone.startsWith("02")) &&
      phone.length === 11) ||
    ((phone.startsWith("03") ||
      phone.startsWith("05") ||
      phone.startsWith("07") ||
      phone.startsWith("08") ||
      phone.startsWith("09")) &&
      phone.length === 10)
  )
    return true
  return false
}

export function formatPhone(phone) {
  return phone.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3")
}

export function getMsgClient(message) {
  return message.indexOf("[!|") !== -1 && message.indexOf("|!]") !== -1
    ? message.split("[!|")[0].trim() + message.split("|!]")[1]
    : message
}

export function validateEmail(email) {
  const re = getRegexEmail()
  return re?.test(String(email)?.toLowerCase())
}

export function getRegexEmail() {
  const re =
    /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+(?<!\.)@(?:[a-zA-Z\d-]+\.)+[a-zA-Z]{2,6}$/
  return re
}
export function validateMobile(mobile) {
  const re = getRegexMobile()
  return re?.test(String(mobile)?.toLowerCase())
}

export function getRegexBrandName() {
  const re = /^(?!.*[-_\\.\\s]{2})([a-zA-Z0-9-_\\.\\s]{0,10}[a-zA-Z0-9])?$/
  return re
}

export function getRegexPhoneNumber() {
  const re = /^(\+84|84|0)+(9|3|7|8|5)+([0-9]{8})\b/g
  return re
}

export function getRegexMobile() {
  const re = /^[0-9]{1}[0-9\s\-().]{6,13}[0-9]{1}$/
  return re
}
export function getRegexPhoneNumberVN() {
  const re =
    /^((\+84|84|0)-?(3|5|7|8|9)-?\d{7,8})$|^((\+84|84|0)-?(2\d{1,2})-?\d{7,8})$/
  return re
}

export function getNumberMinMax() {
  const re = /^(1?[0-9]|20)$/
  return re
}
export function getNumberMinMax1_45() {
  const re = /^(4[0-5]|[1-3][0-9]|[1-9])$/
  return re
}
export function getNumberMinMax1_10() {
  const re = /^(10|[1-9])$/
  return re
}
export const decodeHtml = textInput => {
  if (!textInput) return ""
  const removeHtml = textInput.replace(/<\/?[^>]+(>|$)/g, "")
  const decode = Encoder.htmlDecode(removeHtml)
  return decode
}

export const stripHtml = textInput => {
  if (!textInput) return ""
  return textInput.replace(/<\/?[^>]+(>|$)/g, "")
}

export const convertContent = text => {
  let content
  try {
    const parseText = JSON.parse(decodeHtml(text))
    content = [parseText?.ActionName, parseText?.ProcessedContent]
      .join(parseText?.ActionName && parseText?.ProcessedContent ? ": " : "")
      .concat(
        parseText?.SendReportHandle ? ` ${parseText?.SendReportHandle}` : "",
      )
  } catch (e) {
    content = text
  }
  return content
}

export const fixImplicateText = text => {
  if (!text) return ""
  return text
    ?.replace(/↵/g, " ")
    ?.replace(/(<div>|<p>)/g, "&nbsp;<span>")
    ?.replace(/(<\/div>|<\/p>)/g, "</span>")
    ?.replace(/(<div |<p )/g, "&nbsp;<span ")
    ?.replace(/(<br>|<br\/>|<\/br>|<br \/>)/g, " ")
}

export function getTimeSpent() {
  const re = /^(d[g|h]?)?(d{1}?[05][m|p])?$/
  return re
}

export function formatUserName(fullName, userName, deptName) {
  if (!userName) return `${fullName} - ${deptName}`
  if (!deptName) return ` ${userName} - ${fullName} `
  return `${fullName} - (${userName}) - ${deptName}`
}

export function getRegexNumber() {
  const re = /^[0-9]+$/
  return re
}
export function getRegexNumberLagerZero() {
  // [1-9] đảm bảo chữ số đầu tiên không phải 0, sau đó có thể có 0 hoặc nhiều chữ số
  const re = /^(?:[1-9]\d*)$/
  return re
}

export function getRegexNumberMoreThan0() {
  const re = /^[1-9][0-9]*$/
  return re
}

export function getRegexNumberAcreage() {
  const re = /^\d+(\.\d+)?$/
  return re
}
export function getRegexNumberPattern() {
  const re = /^\d{5}$/
  return re
}
export function getRegexProfileCode() {
  const re = /^[0-9-]*$/
  return re
}

export function removeVietnameseAccents(str) {
  // Dùng bảng mã Unicode để thay thế các ký tự có dấu bằng các ký tự không dấu
  str = str.replace(/á|à|ả|ã|ạ|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/g, "a")
  str = str.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/g, "e")
  str = str.replace(/í|ì|ỉ|ĩ|ị/g, "i")
  str = str.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/g, "o")
  str = str.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/g, "u")
  str = str.replace(/ý|ỳ|ỷ|ỹ|ỵ/g, "y")
  str = str.replace(/đ/g, "d")
  str = str.replace(/Đ/g, "D")

  return str
}

export function convertNumberToVietnamese(num) {
  // Nếu số bằng 0
  if (num === 0) return "Không"

  // Các từ đọc cho các chữ số
  const ones = [
    "không",
    "một",
    "hai",
    "ba",
    "bốn",
    "năm",
    "sáu",
    "bảy",
    "tám",
    "chín",
  ]
  // Các đơn vị cho các nhóm
  const scales = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ", "tỷ tỷ"]

  // Xử lý số âm
  let isNegative = num < 0
  if (isNegative) num = Math.abs(num)

  // Chuyển số thành chuỗi và thêm số 0 phía trước để độ dài chia hết cho 3
  let s = num.toString()
  let padLength = (3 - (s.length % 3)) % 3
  s = "0".repeat(padLength) + s

  // Tách chuỗi thành các nhóm 3 chữ số và chuyển về số nguyên
  let groups = []
  for (let i = 0; i < s.length; i += 3) {
    groups.push(parseInt(s.substring(i, i + 3)))
  }

  // Hàm chuyển 3 chữ số (0 - 999) sang chữ tiếng Việt
  function convertThreeDigits(number, isFirstGroup) {
    let result = ""
    if (number < 100 && isFirstGroup) {
      // Với nhóm đầu tiên nếu số nhỏ hơn 100, xử lý theo quy tắc không thêm "không trăm"
      if (number < 10) {
        result = ones[number]
      } else {
        let tens = Math.floor(number / 10)
        let unit = number % 10
        if (tens === 1) result = "mười"
        else result = ones[tens] + " mươi"

        if (unit !== 0) {
          if (unit === 1 && tens > 1) result += " mốt"
          else if (unit === 4 && tens > 1) result += " tư"
          else if (unit === 5) result += " lăm"
          else result += " " + ones[unit]
        }
      }
    } else {
      // Xử lý số có từ 100 đến 999 (các nhóm không phải nhóm đầu tiên hoặc có đủ 3 chữ số)
      let hundred = Math.floor(number / 100)
      let tens = Math.floor((number % 100) / 10)
      let unit = number % 10

      result += ones[hundred] + " trăm"
      if (tens === 0) {
        if (unit !== 0) result += " lẻ"
      } else if (tens === 1) {
        result += " mười"
      } else {
        result += " " + ones[tens] + " mươi"
      }

      if (unit !== 0) {
        if (tens >= 1) {
          if (unit === 1 && tens > 1) result += " mốt"
          else if (unit === 4 && tens > 1) result += " tư"
          else if (unit === 5) result += " lăm"
          else result += " " + ones[unit]
        } else {
          result += " " + ones[unit]
        }
      }
    }
    return result.trim()
  }

  // Xây dựng kết quả từ các nhóm đã chuyển đổi
  let resultGroups = []
  let groupCount = groups.length
  for (let i = 0; i < groupCount; i++) {
    let groupNum = groups[i]
    let isFirstGroup = i === 0

    // Nếu nhóm là số 0 và không phải là nhóm duy nhất, bỏ qua nhóm đó.
    if (groupNum === 0 && groupCount > 1) {
      // Đặc biệt: nếu nhóm 0 nằm giữa thì đôi khi cần hiển thị "không trăm" nếu nhóm bên phải có giá trị,
      // nhưng đối với số ví dụ của bạn (trong đó nhóm cuối cùng là 000) thì bỏ qua.
      // Bạn có thể tùy chỉnh theo yêu cầu cụ thể.
      if (i === groupCount - 1) continue
      else {
        // Nếu nhóm giữa là 0, để tránh mất scale (ví dụ: "triệu", "nghìn") thì thêm chuỗi rỗng.
        resultGroups.push("")
        continue
      }
    }

    let groupText = convertThreeDigits(groupNum, isFirstGroup)
    let scaleIndex = groupCount - 1 - i
    if (scaleIndex > 0 && groupText !== "") {
      groupText += " " + scales[scaleIndex]
    }
    resultGroups.push(groupText)
  }

  let result = resultGroups.filter(item => item !== "").join(" ")
  result = result.replace(/\s+/g, " ").trim()

  if (isNegative) result = "Âm " + result
  // Viết hoa chữ cái đầu tiên
  return result.charAt(0).toUpperCase() + result.slice(1)
}
